export default "__VITE_ASSET__DSusemFH__"